/**
 * @ngdoc function
 * @name lmApp.controller:LiveController
 * @description
 * # LiveController
 * Controller of the lmApp
 */

lmApp
  .controller('LiveController2', ['$routeParams', '$location', '$q', '$scope', '$templateCache', '$compile', '$rootScope', '$timeout', 'ValidatorService', 'AssetService', 'MetadataService', 'ToastService', 'ModalWindowService', 'ModalConfirmService', 'VirtualLiveApiService', 'ImportService', 'AssetResource',
    function ($routeParams, $location, $q, $scope, $templateCache, $compile, $rootScope, $timeout, ValidatorService, AssetService, MetadataService, ToastService, ModalWindowService, ModalConfirmService, VirtualLiveApiService, ImportService, AssetResource) {
      $rootScope.EVENTS = _.extend($rootScope.EVENTS, {UPDATE_LIVE_COLLECTION: 'update:live:collection'});

      $scope.collection = [];
      $scope.loading = false;
      $scope.importInProgress = false;

      $scope.getAssetType = function (asset) {

        switch (true) {
          case asset.type === 'channel' && asset.channel_type !== 'playlist':
            return 'channel';
            break;

          case asset.type === 'channel' && asset.channel_type === 'playlist':
            return 'virtual-channel';
            break;

          case asset.type === 'package' && asset.package_type === 'tv_series':
            return 'tv_series';
            break;

          case asset.type === 'movie' && !!asset.tv_series_episode:
            return 'tv_episode';
            break;

          case asset.type === 'movie':
            return 'movie';
            break;
        }

      };

      $scope._STREAM_TYPES_ATTRS = MetadataService._STREAM_TYPES_ATTRS;

      $scope.parseAsset = function (asset) {
        asset._PrivateData = {};

        asset.type = $scope.getAssetType(asset);

        asset.resources.forEach(function (resource) {

          if (resource.type === 'stream' && resource.stream_type.indexOf('youtube') !== -1) {
            asset._has_youtube = true;
            resource.stream_type = 'youtube';
            resource._stream_sub_type = 'y';
          }
        });

        if (asset.channel_type === 'playlist') {

          asset._playlist = {};

          VirtualLiveApiService.GetPlaylist(asset.id)
            .then(function (playlist) {
              asset._playlist = playlist;

            });
        }

        return asset;
      };

      $scope.total = 0;

      var getTotal = function(params) {
        params = {};
        params['type[in]'] = 'channel';

        AssetResource.count(params).$promise
          .then(function (response) {
            $scope.total = response.data ? response.data : 0;
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason);
            });
      };

      $scope.collectionData = {
        empty: false,
        error: '',
        filters: {
          genres: [],
          categories: [],
          keyword: ''
        },
        offset: 0,
        limit: 20,
        isStart: false,
        isEnd: false,
        isEmpty: function () {
          return !$scope.loading && !$scope.collection.length;
        },
        update: function (who) {
          if (!who.isSilentUpdate) {
            $scope.loading = true;
            $rootScope.showLinearProgress('#liveCollectionLoader');
          }

          getTotal();

          $scope.collectionData.empty = false;
          $scope.collectionData.error = false;

          var allQ = {};

          if (ValidatorService.Numerical(who.id)) {
            allQ.byId = AssetService.GetAssetById(who.id);
          }

          if (who.id === 'all') {
            $scope.collection = [];
            this.isEnd = false;
            this.isStart = false;

            this.isStart = this.offset < this.limit;

            if ($scope.collectionData.filters.keyword ||
              $scope.collectionData.filters.genres.length ||
              $scope.collectionData.filters.categories.length) {

              allQ.allLive = AssetService.Search($scope.collectionData.filters.keyword, {
                genres: _.map($scope.collectionData.filters.genres, 'id'),
                categories: _.map($scope.collectionData.filters.categories, 'id'),
                view: 'live'
              }, this.offset, this.limit + 1)
                .then(function (collection) {
                  if (collection.length < this.limit + 1) {
                    this.isEnd = true;
                  } else {
                    collection.pop();
                  }
                  return collection;
                }.bind(this));

            } else {
              allQ.allLive = AssetService.GetAllAvailableChannels(this.offset, this.limit + 1)
                .then(function (collection) {
                  if (collection.length < this.limit + 1) {
                    this.isEnd = true;
                  } else {
                    collection.pop();
                  }
                  return collection;
                }.bind(this));
            }
          }

          return $q.all(allQ)
            .then(function (response) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#liveCollectionLoader');

              if (response.byId) {
                if (!response.byId.length) {
                  this.update({id: 'all'});
                  return;
                }

                var tmpAsset = response.byId[0];

                tmpAsset = $scope.parseAsset(tmpAsset);

                var found;
                if (who.isSearch) {
                  $scope.collection = [tmpAsset];
                  this.isEnd = true;

                } else if (who.collection) {
                  console.log('Check this: ', location && location.href);

                  found = _.find(who.collection, {id: tmpAsset.id});
                } else {

                  found = _.find($scope.collection, {id: tmpAsset.id});
                }

                _.assign(found, tmpAsset);

                return $q.when(found);
              }

              if (response.allLive) {

                if (!response.allLive.length && $scope.collectionData.offset > 0) {
                  $scope.collectionData.offset = 0;
                  $scope.collectionData.limit = 20;
                  $rootScope.$broadcast($rootScope.EVENTS.UPDATE_LIVE_COLLECTION, {
                    id: 'all'
                  });

                  $location.search('page', 1);

                  return;
                }

                response.allLive.forEach($scope.parseAsset);

                if (!response.allLive.length) {
                  $scope.collectionData.empty = true;
                }

                $scope.collection = response.allLive;

                if ($scope.routeLiveId) {
                  var currentLiveIndex = _.findIndex($scope.collection, {id: $scope.routeLiveId});

                  if (currentLiveIndex !== -1) {
                    $scope.openModal($scope.collection[currentLiveIndex], currentLiveIndex, $scope.collection, null, false);
                  } else {
                    $location.search('live_id', null);
                  }
                }

                return $q.when($scope.collection);
              }
            }.bind(this))
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#liveCollectionLoader');
              ToastService.Small({
                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                color: 'amber',
                icon: 'server-off',
                blocked: true
              }, 1000 * 3);
              $rootScope.debugInfo(reason, 'silent');
              return false;
            });
        },
        nextPage: function () {
          if (this.isEnd) return;
          $scope.routePage = $scope.routePage + 1;
          $location.search('page', $scope.routePage);
          this.offset += $scope.collectionData.limit;
          $rootScope.$broadcast($rootScope.EVENTS.UPDATE_LIVE_COLLECTION, {id: 'all'});
        },
        prevPage: function () {
          if (this.isStart) return;

          if (this.offset >= this.limit) {
            this.offset -= this.limit;
            $scope.routePage = $scope.routePage - 1;
            $location.search('page', $scope.routePage);
          } else {
            this.offset = 0;
            $location.search('page', 1);
          }
          $rootScope.$broadcast($rootScope.EVENTS.UPDATE_LIVE_COLLECTION, {id: 'all'});
        }
      };

      $scope.applyFilters = function (filters) {
        if ($scope.loading || _.isEmpty(filters)) return;

        if (filters.keyword ||
          filters.genres.length ||
          filters.categories.length) {
          $scope.collectionData.offset = 0;
        }

        if (ValidatorService.Numerical(filters.keyword)) {
          $rootScope.$broadcast($rootScope.EVENTS.UPDATE_LIVE_COLLECTION, {
            id: filters.keyword,
            isSearch: true
          });
        } else {
          $rootScope.$broadcast($rootScope.EVENTS.UPDATE_LIVE_COLLECTION, {id: 'all'})
        }
      };

      $scope.deleteAsset = function (asset, event) {
        if (event && event.stopPropagation) event.stopPropagation();
        if (event && event.preventDefault) event.preventDefault();

        ModalConfirmService.Open({
          content: '<p class="fs-headline tc-red-800"> Delete </p> <p class="fs-title">This action will delete content permanently. ' +
          'Are You sure? </p>',
          action: {
            title: 'Delete',
            fn: function () {
              $scope.loading = true;
              $rootScope.showLinearProgress('#liveCollectionLoader');

              AssetService.DeleteAsset(asset)
                .then(function (response) {
                  $scope.loading = false;
                  $rootScope.hideLinearProgress('#liveCollectionLoader');
                  ToastService.Small({
                    title: 'TV Channel: <b class="tc-white"> ' + asset.title + '</b> successfully deleted',
                    color: 'green',
                    icon: 'delete'
                  }, 1000 * 3);
                  $rootScope.$broadcast($rootScope.EVENTS.UPDATE_LIVE_COLLECTION, {
                    id: 'all'
                  });
                })
                .catch(function () {
                  $scope.loading = false;
                  $rootScope.hideLinearProgress('#liveCollectionLoader');
                  $rootScope.debugInfo(reason);
                  ToastService.Small({
                    title: 'TV Channel: <b class="tc-white"> ' + asset.title + '</b> delete failed',
                    color: 'red',
                    icon: 'delete'
                  }, 1000 * 3);
                });
            }
          }
        });
      };

      //When modal window open = save Data for edit
      $scope.openModal = function (assetData, index, collection, e, isNewType) {
        if (e && e.preventDefault) e.preventDefault();
        if (e && e.stopPropagation) e.stopPropagation();

        var modalScope = $rootScope.$new();

        modalScope.currentFocused = index;
        modalScope.localCollection = collection;
        modalScope.isNewType = isNewType;

        if (isNewType) {
          switch (isNewType) {
            case 'channel':
              var originAssetData = {
                platform_id: [],
                categories: [],
                traits: [],
                operator_id: [],
                resources: [],
                genres: [],
                is_epg_available: false,
                views: [],
                offers: [],
                group_id: [],
                package_id: [],
                tags: []
              };
              originAssetData._PrivateData = {};
              originAssetData._PrivateData.isNew = true;
              originAssetData.type = isNewType;
              _.defaults(originAssetData, assetData);
              break;

            case 'virtual-channel':
              var originAssetData = {
                platform_id: [],
                categories: [],
                traits: [],
                operator_id: [],
                resources: [],
                genres: [],
                views: [],
                offers: [],
                group_id: [],
                package_id: [],
                tags: [],
                _playlist: {
                  groups: [],
                  start: 0
                }
              };

              originAssetData._PrivateData = {};
              originAssetData._PrivateData.isNew = true;
              originAssetData.type = isNewType;
              _.defaults(originAssetData, assetData);
              break;
          }

          modalScope.asset = originAssetData;
        } else {
          modalScope.asset = angular.copy(assetData);
          modalScope.asset._PrivateData = {};
          $location.search('live_id', modalScope.asset.id);
        }

        modalScope.loading = false;

        modalScope.processAsset = function (asset) {
          if (modalScope.loading) return;

          if (asset._PrivateData.isNew) {
            modalScope.createFn(asset);
          } else {
            modalScope.updateFn(asset, modalScope.currentFocused);
          }
        };

        modalScope.setCurrentQuality = function (asset, value) {

          MetadataService.Quality.SetValue(asset, value);
        };

        modalScope.isFirst = function () {
          return !modalScope.currentFocused;
        };

        modalScope.isLast = function () {
          return modalScope.localCollection && modalScope.currentFocused === modalScope.localCollection.length - 1;
        };

        modalScope.close = function () {
          if (modalScope.loading) return;

          modalScope.fullscreenToogle(false);
          ModalWindowService.Close($scope.window, false);
          $location.search('live_id', null);
        };

        modalScope.fullscreenToogle = function (state) {
          if (typeof state !== 'undefined') {
            modalScope.fullscreen = state;
          } else {
            modalScope.fullscreen = !modalScope.fullscreen;
          }

          ModalWindowService.Fullscreen($scope.window, state);
        };

        modalScope._modalWindow_ = $templateCache.get('lm-assets-edit/edit-window.tpl.html');

        modalScope._modalWindow_ = $compile(modalScope._modalWindow_)(modalScope);

        $scope.window = ModalWindowService.Open({
          content: modalScope._modalWindow_,
          navigation: $compile($templateCache.get('lm-assets-edit/navigation-buttons.tpl.html'))(modalScope),
          clear: true,
          keyboard: true,
          size: {
            s: 11,
            l: 10
          },
          clearRoute: ['vod_id']
        });

        modalScope._modalWindow_.on('$destroy', function () {
          modalScope.$destroy();
        })
      };

      $scope.importPerform = function () {

        $timeout(function () {
          angular.element('#import_xml').trigger('click');
        });
      };

      $timeout(function () {
        angular.element('#import_xml')
          .on('change', function () {
            $scope._progress_ = angular.element('#importProgress');
            $scope._bar_ = $scope._progress_.find('.determinate');

            $scope.error = '';
            if (!this.files || !this.files.length) {
              ToastService.Small({
                title: 'Please, choose at least one file',
                color: 'red',
                icon: 'arrow-down-bold-hexagon-outline'
              }, 1000 * 60);

              return;
            }

            var file = this.files[0];

            if (file.type !== 'text/xml') {
              ToastService.Small({
                title: 'File should be in XML format',
                color: 'red',
                icon: 'arrow-down-bold-hexagon-outline'
              }, 1000 * 60);

              return;
            }

            $scope.importInProgress = true;
            $scope._progress_.css({'display': 'block'});

            angular.element('#import_xml').innerHTML =  angular.element('#import_xml').innerHTML;

            ImportService.UploadToCloud(file, $scope._progress_)
              .then(function (response) {
                $scope._progress_.css({'display': 'none'});
                $scope._bar_.css({width: 0});

                ImportService.CreatePerformImport(response.Location)
                  .then(function () {
                    $scope.importInProgress = false;

                    ToastService.Big({
                      title: 'Import will continue in background. Check this page later.',
                      color: 'green',
                      icon: 'arrow-down-bold-hexagon-outline'
                    }, 1000 * 60);
                  })
                  .catch(function (reason) {
                    $rootScope.debugInfo(reason);
                  });
              }, function (reason) {
                $scope.importInProgress = false;
                $scope._progress_.css({'display': 'none'});
                $scope._bar_.css({width: 0});

                $rootScope.debugInfo(reason);
              });
          });
      }, 600);

      $scope.broadcastListener = $rootScope.$on($rootScope.EVENTS.UPDATE_LIVE_COLLECTION, function (event, data) {
        $scope.collectionData.update(data);
      });

      /**
       * Init collection on controller add
       */
      $scope.routePage = 1;
      if (!_.isUndefined($routeParams.page) && $routeParams.page > 0) {
        $scope.routePage = Number($routeParams.page);
        $scope.collectionData.offset = ($scope.routePage - 1) * $scope.collectionData.limit;
        $scope.collectionData.limit = 20;
      } else {
        $location.search('page', 1);
      }

      $scope.routeLiveId = null;
      if (!_.isUndefined($routeParams.live_id)) {
        $scope.routeLiveId = Number($routeParams.live_id);
      } else {
        $location.search('live_id', null);
      }

      $scope.routeKeyword = '';
      if (!_.isUndefined($routeParams.keyword)) {
        $scope.routeKeyword = $routeParams.keyword;
        $scope.collectionData.filters.keyword = $routeParams.keyword;
      } else {
        $location.search('keyword', null);
      }

      $scope.watcherFiler = $scope.$watchCollection('collectionData.filters', function (newValue, oldValue) {
        if (oldValue && newValue) {

          //TODO: Check this logic
          if (!newValue.keyword && !newValue.genres.length && !newValue.categories.length
            && (oldValue.keyword || oldValue.genres.length || oldValue.categories.length)) {
            $scope.collectionData.offset = 0;
            $location.search('page', 1);
            $scope.applyFilters(newValue);
            $location.search('keyword', null);
          }

          //if (!oldValue.keyword && !oldValue.genres.length && !oldValue.categories.length) {
          //  $scope.collectionData.offset = 0;
          //}

          if (newValue.keyword || newValue.genres.length || newValue.categories.length) {
            $location.search('page', 1);
            if (newValue.keyword) $location.search('keyword', newValue.keyword);
            $scope.applyFilters(newValue);
          }
        }
      });

      $scope.$on('$routeUpdate', function () {
        $scope.routePage = $routeParams.page || 1;

        if ($scope.routeLiveId && !$routeParams.live_id) {
          ModalWindowService.Close($scope.window, false);
        }
        $scope.routeLiveId = Number($routeParams.live_id) || null;

        if ($scope.routeKeyword && !$routeParams.keyword) {
          $scope.collectionData.filters.keyword = '';
          $scope.routeKeyword = '';
          $rootScope.$broadcast($rootScope.EVENTS.UPDATE_LIVE_COLLECTION, {id: 'all', collection: $scope.collection});
        }
        $scope.routeKeyword = $routeParams.keyword || '';
      });

      $scope.applyFilters($scope.collectionData.filters);

      AssetService.GetPlatforms()
        .then(function (data) {
          $rootScope.platforms = data;
        })
        .catch(function (reason) {
          $rootScope.debugInfo(reason);
        });

      $scope.$on('$destroy', function () {
        $scope.watcherFiler();
        $scope.broadcastListener();

        angular.element('#import_xml').off('change');
      });

    }]);
